import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import { PHYSICS } from '../../../data/studioLabs';
import './PhysicsPlay.css';

const COPY = {
  forces: 'Push a crate. Feel friction steal the force. When a > 0, it actually moves.',
  energy: 'Height is a bank account. Friction is the fee. Watch PE become KE.',
  rotation: 'Same torque, different I. A hoop hates to spin. A disk does not.',
  vibration: 'A live mass-spring-damper. Tune ζ and watch the ring die — or not.',
  fluids: 'Narrow the pipe. Speed up. Pressure drops. Bernoulli on a line, not a textbook.',
  heat: 'Watts through a wall. Change k, L, ΔT. This is every thermal stack you will ever size.',
};

const PhysicsOverview = () => {
  useEffect(() => {
    document.documentElement.classList.add('qn-home-html');
    document.body.classList.add('qn-home-body');
    return () => {
      document.documentElement.classList.remove('qn-home-html');
      document.body.classList.remove('qn-home-body');
    };
  }, []);

  return (
    <div className="pp-lab">
      <Header />
      <main className="pp-main">
        <Link to="/virtuallabs" className="pp-back">← All labs</Link>
        <p className="pp-kicker">For every engineer</p>
        <h1>Engineering Physics Playground</h1>
        <p className="pp-lead">
          Six benches you can fiddle with. No medical lectures. Generated courses drop you here
          when the job needs forces, energy, spin, shake, flow, or heat — then you go back to the briefing.
        </p>
        <div className="pp-grid">
          {PHYSICS.benches.map((b, i) => (
            <Link key={b.id} to={b.path} className="pp-card">
              <em>Bench {i + 1}</em>
              <h2>{b.title}</h2>
              <p>{COPY[b.id]}</p>
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PhysicsOverview;
